import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { TabWatcher, useTabContext } from '../../contexts/TabContext';
import useIsMobile from '../../hooks/useIsMobile';
import styles from './Layout.module.css';

function TabPanels({ mobile }) {
  const { tabs, activeId } = useTabContext();

  return (
    <>
      {tabs.map(tab => {
        // No celular, a rota com versão mobile própria (ROTAS[].M) usa ela
        const Tela = mobile && tab.M ? tab.M : tab.C;
        return (
          <main
            key={tab.path}
            className={styles.content}
            style={{ display: tab.path === activeId ? 'block' : 'none' }}
          >
            <Tela />
          </main>
        );
      })}
      {tabs.length === 0 && (
        <main className={styles.content} />
      )}
    </>
  );
}

// Celular só chega no Layout no modo completo (suporterb nos sites de gestão —
// ver GuardaMobile): menu lateral vira gaveta aberta pelo ☰.
function BarraMobile({ onMenu }) {
  const { tabs, activeId } = useTabContext();
  const atual = tabs.find(t => t.path === activeId);
  return (
    <div className={styles.barraMobile}>
      <button className={styles.hamburguer} onClick={onMenu} aria-label="Abrir menu">☰</button>
      <span className={styles.tituloMobile}>{atual ? `${atual.icon} ${atual.label}` : ''}</span>
      <Link to="/mobile" className={styles.inicioMobile} title="Menu inicial">🏠</Link>
    </div>
  );
}

export default function Layout() {
  const mobile = useIsMobile();
  const [menuAberto, setMenuAberto] = useState(false);
  const location = useLocation();

  useEffect(() => { setMenuAberto(false); }, [location.pathname]);

  return (
    <div className={`${styles.container} ${mobile ? styles.mobile : ''}`}>
      <TabWatcher />
      {mobile && menuAberto && <div className={styles.fundoGaveta} onClick={() => setMenuAberto(false)} />}
      <Sidebar gaveta={mobile} aberta={menuAberto} />
      <div className={styles.main}>
        {mobile && <BarraMobile onMenu={() => setMenuAberto(true)} />}
        <Header />
        <TabPanels mobile={mobile} />
      </div>
    </div>
  );
}
